export default __webpack_public_path__ + "static/media/whiteBackground_feedback.3be16b8b.svg";